module.exports = __webpack_public_path__ + "img/e-tjx-gdjd-icon@2x.4564dd50.png";